import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=3f7e3751"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports